export enum ActiveInactiveStatusEnum {
  ACTIVE,
  INACTIVE,
}
